import { render, staticRenderFns } from "./ReSearchCardClient.vue?vue&type=template&id=6160ad3c&scoped=true"
import script from "./ReSearchCardClient.vue?vue&type=script&lang=js"
export * from "./ReSearchCardClient.vue?vue&type=script&lang=js"
import style0 from "./ReSearchCardClient.vue?vue&type=style&index=0&id=6160ad3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6160ad3c",
  null
  
)

export default component.exports